import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaArrowLeft } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa6";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Images
import slide1 from "../assets/imgs/slider1.webp";
import slide2 from "../assets/imgs/slider2.webp";
import slide3 from "../assets/imgs/slider3.webp";
import slide4 from "../assets/imgs/slider4.webp";
import slidermo1 from "../assets/imgs/slider-mo1.png";
import slidermo2 from "../assets/imgs/slider-mo2.png";
import slidermo3 from "../assets/imgs/slider-mo3.png";
import slidermo4 from "../assets/imgs/slider-mo4.png";

const sliderImages = [
  {
    src: slide1,
    title: "Free federal and state tax filing. Seriously.",
  },
  {
    src: slide2,
    title: "Expert tax filing. Zero expert fees.",
  },
  {
    src: slide3,
    title: "$0 federal. $0 state. $0 catch.",
  },
  {
    src: slide4,
    title: "IRS Security Six compliant. All data is encrypted, and never sold/stored externally.",
  },
];

const sliderMobileImages = [
  {
    src: slidermo1,
    title: "Free federal and state tax filing. Seriously.",
  },
  {
    src: slidermo2,
    title: "$0 federal. $0 state. $0 catch.",
  },
  {
    src: slidermo3,
    title: "IRS Security Six compliant. All data is encrypted, and never sold/stored externally.",
  },
  // {
  //   src: slidermo4,
  //   title: "Track your tax return status from preparation to refund.",
  // },
];

export default function AuthSlider() {
  const renderSwiper = (images) => (
    <Swiper
      modules={[Autoplay, Pagination, Navigation]}
      slidesPerView={1}
      loop={true}
      // autoplay={{
      //   delay: 2000,
      //   disableOnInteraction: false,
      // }}
      pagination={{
        el: ".custom-swiper-pagination",
        type: "bullets",
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className} custom-bullet"></span>`;
        },
      }}
      navigation={{
        prevEl: ".custom-swiper-prev",
        nextEl: ".custom-swiper-next",
      }}
      className="mySwiper"
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <p className="h-[138px] text-2xl 2xl:text-[36px] font-semibold text-white p-5 md:pt-[10%] md:pr-[15%] md:pl-[11%]">
            {image.title}
          </p>
          <img
            src={image.src}
            className="float-right rounded-tl-[20px] w-[85%] h-auto md:max-h-100 md:w-[90%] md:mt-[30%] mt-[5%]"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );

  return (
    <div className="hidden md:block md:m-auto md:w-[30%]">
      <div className="auth-slider rounded-2xl min-h-[97vh]">
        {/* 🖥 Desktop Slider only */}
        <div>{renderSwiper(sliderImages)}</div>
        {/* Desktop Controls */}
        <div className="mt-[19%] px-8">
          <div className="flex items-center justify-center">
            <button className="custom-swiper-prev text-white bg-[#C8FFEC0D] border border-gray-500 rounded-[30px] py-[5px] px-[20px] mx-[30px] xl:mr-[30px] xl:ml-0 cursor-pointer">
              <FaArrowLeft />
            </button>

            <div className="custom-swiper-pagination flex items-center justify-center hidden xl:block" />

            <button className="custom-swiper-next text-white bg-[#C8FFEC0D] border border-gray-500 rounded-[30px] py-[5px] px-[20px] mx-[30px] xl:ml-[30px] xl:mr-0 cursor-pointer">
              <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
